import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form } from "reactstrap";
import { get, put } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import UploadImage from "common/uploadImage";
import { SHOW_BANNER, UPDATE_BANNER } from "helpers/api_endpoints";

//meta title
document.title = "Edit Banner";

const EditBanner = () => {

    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [status, setStatus] = useState(0);
    const [name, setname] = useState('');
    const [text, setText] = useState('');
    const [shape, setShape] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        get(`${SHOW_BANNER}/${params.id}`)
            .then(response => {
                const banner = response.data;
                setid(params.id);
                setname(banner.name);
                setStatus(banner.status);
                setText(banner.text);
                setImage(banner.image);
                setShape(banner.shape);
                setDescription(banner.description);
                setLoading(false);
            })
            .catch(error => {
                navigate('/banners');
            })
    }, []);

    const handleSubmit = () => {
        const imagePath = document.getElementById('imagePath').value;
        put(UPDATE_BANNER, { id, name, status, text, shape, description, image: imagePath })
            .then(response => {
                if (response.code == 200) {
                    navigate('/banners', { state: { successMsg: 'Banner Updated SuccessFully' } });
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    }

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Banners" breadcrumbItem="Edit Banner" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Name</Trans></Label>
                                                    <Input
                                                        name="username"
                                                        value={name}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => setname(e.target.value)}
                                                        required ></Input>
                                                    <Input type="hidden" name="id"></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Shape</Trans></Label>
                                                    <Input
                                                        name="shape"
                                                        value={shape}
                                                        className="form-control"
                                                        placeholder="Enter Shape"
                                                        type="number"
                                                        onChange={(e) => setShape(e.target.value)}
                                                    ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Text</Trans></Label>
                                                    <Input
                                                        name="text"
                                                        value={text}
                                                        className="form-control"
                                                        placeholder="Enter Text"
                                                        type="text"
                                                        onChange={(e) => setText(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Description</Trans></Label>
                                                    <textarea name="description"
                                                        className="form-control"
                                                        placeholder="Enter Description"
                                                        value={description}
                                                        onChange={(e) => setDescription(e.target.value)}></textarea>
                                                </div>

                                                <UploadImage state={{ InputLabel: 'Image', filePath: image, type: 'banners', isFullPath: true }}></UploadImage>

                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value={1}
                                                            id="defaultCheck2"
                                                            checked={status == 1}
                                                            onClick={handleToggleCheckBoxStatus}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="defaultCheck2"
                                                        >
                                                            <Trans>Active</Trans>
                                                        </label>
                                                    </div>
                                                </div>


                                                <div className="mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditBanner
